import _ from 'lodash';
import * as Yup from 'yup';
import { AIRTABLE, XANO, SUPABASE, NOTION, permissionTypes, pluginCode } from 'drapcode-constant';
import { loadOrganizationDetails } from '../../../common/utils/check-auth';
import { showAlertHtml } from '../../../common/utils/alert';
const {
  ATOMCHAT,
  AWS_S3,
  AWS_SES,
  AWS_SNS,
  AWS_TEXTRACT,
  BACKGROUND_TASK,
  BNG_PAYMENT,
  CHAT_GPT,
  CHATGPT_CHATBOT_MESSAGING,
  DATA_FORM_SEARCH_HISTORY,
  DATA_VIEW_ACTIVITY_TRACKER,
  DOCUSIGN,
  EMAIL_OTP_AUTHENTICATOR,
  FACEBOOK_LOGIN,
  FILE_ACTIVITY_TRACKER,
  FLUID_PAY,
  IMAGINE_PAY,
  LOAN_MANAGEMENT,

  LOGIN_WITH_XANO,
  MAGIC_LINK_LOGIN,
  MESSAGING,
  MULTI_TENANT_SAAS,
  PLAID,
  SNIPCART,
  STRIPE_CONNECT,
  STRIPE_PAYMENT_METHODS,
  TWILIO,
  TWITTER_LOGIN,
  TWO_FACTOR_AUTHENTICATION,
  PERMISSIONS_MANAGE,
  OAUTH_2,
  AUDIT_LOG,
  AUDIT_TRAIL,
  AWS_SIGNATURE,
  EMAIL_OTP_CONSENT_VALIDATOR,
  SMS_OTP_AUTHENTICATOR,
  SMS_OTP_CONSENT_VALIDATOR,
  TEXT_ANONYMIZATION_ACTIVITY_TRACKER,
} = permissionTypes;
const restrictedPlugins = [
  ATOMCHAT,
  AWS_S3,
  AWS_SES,
  AWS_SNS,
  AWS_TEXTRACT,
  BACKGROUND_TASK,
  BNG_PAYMENT,
  CHAT_GPT,
  CHATGPT_CHATBOT_MESSAGING,
  DATA_FORM_SEARCH_HISTORY,
  DATA_VIEW_ACTIVITY_TRACKER,
  DOCUSIGN,
  FACEBOOK_LOGIN,
  FILE_ACTIVITY_TRACKER,
  FLUID_PAY,
  IMAGINE_PAY,
  LOAN_MANAGEMENT,

  LOGIN_WITH_XANO,
  MAGIC_LINK_LOGIN,
  MESSAGING,
  MULTI_TENANT_SAAS,
  PLAID,
  OAUTH_2,
  SNIPCART,
  STRIPE_CONNECT,
  STRIPE_PAYMENT_METHODS,
  TWILIO,
  TWITTER_LOGIN,
  TWO_FACTOR_AUTHENTICATION,
  PERMISSIONS_MANAGE,
  AUDIT_LOG,
  AUDIT_TRAIL,
  AWS_SIGNATURE,
  EMAIL_OTP_CONSENT_VALIDATOR,
  SMS_OTP_AUTHENTICATOR,
  SMS_OTP_CONSENT_VALIDATOR,
  TEXT_ANONYMIZATION_ACTIVITY_TRACKER,
  EMAIL_OTP_AUTHENTICATOR,
];

const multiTenantMessage = `Installing Multi Tenant SaaS plugin will make the following changes in the existing & new collections.<br/><br/>
          <ol class="px-3" style="text-align: left;font-size: 14px;">
            <li class="mb-2">The selected Tenant Collection's reference field (non-editable) will be added in all the existing & new Collections.</li>
            <li class="mb-2">A (tenant default) Tenant reference field (tenantId) will have a title of a selected Tenant Collection's name.</li>
            <li class="mb-2">A <em>All Items of Current LoggedIn User Tenant</em> filter will be added to all the existing & new Collections.</li>
            <li class="mb-2">The selected Tenant collection cannot be changed. Please uninstall and reinstall the plugin to set another Tenant collection.</li>
          </ol>
          <p style="text-align: left;">
            <b>Please note:</b> If you need to change the collections, you'll need to uninstall the plugin and then install it again. Editing the collections directly is not possible.
          </p>
          `;
const dataFormMessage = `Installing Data Form Search History plugin will make the following changes in the project<br/><br/>
            <ol class="px-3" style="text-align: left;font-size: 14px;">
              <li class="mb-2">Search History capability will be added to the project.</li>
              <li class="mb-2">A Search History collection will be created.</li>
            </ol>
            `;

const fileActivityMessage = `Installing File Activity Tracker plugin will make the following changes in the project<br/><br/>
            <ol class="px-3" style="text-align: left;font-size: 14px;">
              <li class="mb-2">File Activity Tracking capability will be added to the project.</li>
              <li class="mb-2">A File Activity Tracker collection will be created.</li>
            </ol>
            `;
const userActivityMessage = `Installing User Login Activity Tracker plugin will make the following changes in the project<br/><br/>
            <ol class="px-3" style="text-align: left;font-size: 14px;">
              <li class="mb-2">User Login Activity Tracking capability will be added to the project.</li>
              <li class="mb-2">A User Login Activity Collection will be created.</li>
            </ol>
            `;
const dataActivityMessage = `Installing Data View Activity Tracker plugin will make the following changes in the project<br/><br/>
            <ol class="px-3" style="text-align: left;font-size: 14px;">
              <li class="mb-2">Data Viewing Activity Tracking capability will be added to the project.</li>
              <li class="mb-2">A Data View Activity Tracker collection will be created.</li>
            </ol>
            `;
const textAnonymizationMessage = `Installing the Text Anonymization Activity Tracker plugin will make the following changes to the project:<br/><br/>
              <ol class="px-3" style="text-align: left; font-size: 14px;">
                <li class="mb-2">Text anonymization activity tracking capability will be added to the project.</li>
                <li class="mb-2">A Text Anonymization Activity Collection will be created.</li>
                <li class="mb-2">Text anonymization events will be added to the events section.</li>
              </ol>
              `;
const typesenseMessage = `Installing the Typesense Search plugin will make the following changes to the project:<br/><br/>
              <ol class="px-3" style="text-align: left; font-size: 14px;">
                <li class="mb-2">Typesense Search capability will be added to the project.</li>
                <li class="mb-2">A Typesense Search Component will be created.</li>
                <li class="mb-2">Typesense Mapping section will be added to advanced configuration of collections.</li>
                <li class="mb-2">Typesense events will be added to the events section.</li>
              </ol>
              `;
const socketMessage = `Installing the Socket.IO plugin will make the following changes to the project:<br/><br/>
              <ol class="px-3" style="text-align: left; font-size: 14px;">
                <li class="mb-2">A Send Socket Notification action will be added to the Notifications event list.</li>
                <li class="mb-2">A Socket.IO Template section will be added for dynamic message creation.</li>
                <li class="mb-2">A Socket.IO Activity Tracker Collection will be created.</li>
                <li class="mb-2">A real-time Socket.IO connection will be established between the frontend and backend.</li>
              </ol>
              `;
const sendgridMessage = `Installing the SendGrid plugin will make the following changes to the project:<br/><br/>
              <ol class="px-3" style="text-align: left; font-size: 14px;">
                <li class="mb-2">Email sending capabilities via SendGrid will be integrated into the project.</li>
                <li class="mb-2">SendGrid service will be integrated into the Send Dynamic Email action.</li>
                <li class="mb-2">A SendGrid Activity Tracker Collection will be created.</li>
              </ol>
              `;
const signzyAccountMessage = `Installing the Signzy Account Aggregator plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">Signzy Account Aggregator events will be added to the events categories.</li>
              <li class="mb-2">An Account Aggregator FI Transactions Collection will be created.</li>
              <li class="mb-2">An Account Aggregator Account Holders Collection will be created.</li>
              <li class="mb-2">Request ID, Consent Handle and Internal ID fields will be created in User Collection.</li>
            </ol>
            `;
const signzyDigitalMessage = `Installing the Signzy Digital Document Signing plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">Signzy Digital Document Signing events will be added to the events categories.</li>
              <li class="mb-2">A Digital Document Signing Signers Collection will be created.</li>
              <li class="mb-2">A Digital Document Signing Contracts Collection will be created.</li>
              <li class="mb-2">Contract ID fields will be created in User Collection.</li>
            </ol>
            `;
const googleCalendarMessage = `Installing the Google Calendar plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">Google Calendar events will be added to the events categories.</li>
              <li class="mb-2">A Google Calendar Events Collection will be created.</li>
              <li class="mb-2">A Google Calendar OAUTH Tokens Collection will be created.</li>
            </ol>
            `;

const parkenMessage = `Installing the Parken plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">Parken Option will be added to SMS Service in Send Dynamic SMS Event.</li>
              <li class="mb-2">A Parken SMS Activity Tracker Collection will be created.</li>
            </ol>`;

const resendMessage = `Installing the Resend plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">Email sending capabilities via Resend will be integrated into the project.</li>
              <li class="mb-2">Resend service will be integrated into the Send Dynamic Email action.</li>
              <li class="mb-2">A Resend Activity Tracker Collection will be created.</li>
            </ol>
            `;
const googleMeetMessage = `Installing the Google Meet plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Google Meet OAUTH Tokens Collection will be created.</li>
              <li class="mb-2">Google Meet Events will be added in Google Category.</li>
              <li class="mb-2">A Google Meet option will be added to the Conference Provider in the Schedule Google Calendar Event action.</li>
            </ol>`;
const docuSignMessage = `Installing the DocuSign plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Docusign Tokens Collection will be created.</li>
              <li class="mb-2">A Docusign Contracts Collection will be created.</li>
              <li class="mb-2">A Docusign Signers Collection will be created.</li>
              <li class="mb-2">A Docusign Activity Tracker Collection will be created.</li>
              <li class="mb-2">DocuSign Events category will be added.</li>
            </ol>`;
const zoomMessage = `Installing the Zoom plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Zoom OAUTH Tokens Collection will be created.</li>
              <li class="mb-2">Zoom Events category will be added.</li>
              <li class="mb-2">A Zoom option will be added to the Conference Provider in the Schedule Google Calendar Event action.</li>
            </ol>`;
const cibilMessage = `Installing the Transunion CIBIL plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">CIBIL Events category will be added.</li>
            </ol>`;
const boxMessage = `Installing the Box plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Box OAUTH Tokens Collection will be created.</li>
              <li class="mb-2">Box Events category will be added.</li>
              <li class="mb-2">Box Folders List Component will be added.</li>
            </ol>`;
const qrMessage = `Installing the QR Code Generator plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">QR Events category will be added.</li>
            </ol>`;
const emailOTPMessage = `Installing the Login Via Email OTP plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Email OTPs Collection will be created.</li>
              <li class="mb-2">Email OTP Events will be added.</li>
            </ol>`;
const smsOTPMessage = `Installing the Login Via SMS OTP plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A SMS OTPs Collection will be created.</li>
              <li class="mb-2">SMS OTP Events will be added.</li>
            </ol>`;
const emailConsentOTPMessage = `Installing the Email OTP Consent plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Email Consent OTPs Collection will be created.</li>
              <li class="mb-2">Email Consent OTP Events will be added.</li>
            </ol>`;
const smsConsentOTPMessage = `Installing the SMS OTP Consent plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A SMS Consent OTPs Collection will be created.</li>
              <li class="mb-2">SMS Consent OTP Events will be added.</li>
            </ol>`;
const mPesaMessage = `Installing the M-Pesa plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A MPesa OAUTH Tokens Collection will be created.</li>
              <li class="mb-2">A MPesa Callback Responses Collection will be created.</li>
              <li class="mb-2">M-Pesa Events will be added.</li>
            </ol>`;
const spinMobileMessage = `Installing the Spin Mobile plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Spin Mobile OAUTH Tokens Collection will be created.</li>
              <li class="mb-2">Spin Mobile Events will be added.</li>
            </ol>`;
const iprsKenyaMessage = `Installing the IPRS - Kenya plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A IPRS Kenya Data Collection will be created.</li>
              <li class="mb-2">IPRS - Kenya Event will be added to Spin Mobile Category.</li>
            </ol>`;
const metropolCreditReportsMessage = `Installing the Metropol Credit Reports Bureau - Kenya
 plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A Metropol Credit Reports Collection will be created.</li>
              <li class="mb-2">A Metropol Account Information Collection will be created.</li>
              <li class="mb-2">A Metropol Associations Collection will be created.</li>
              <li class="mb-2">Metropol Credit Report Event will be added to Spin Mobile Category.</li>
            </ol>`;
const kraPinCheckerMessage = `Installing the KRA Pin Checker plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A KRA PIN Checks Collection will be created.</li>
              <li class="mb-2">KRA PIN Checker Event will be added to Spin Mobile Category.</li>
            </ol>`;
const eStatementAnalysisMessage = `Installing the E-Statement Analysis plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">A E-Statement Analysis Collection will be created.</li>
              <li class="mb-2">A E-Statement Analysis Locations Collection will be created.</li>
              <li class="mb-2">A E-Statement Analysis Final Classifications Collection will be created.</li>
              <li class="mb-2">A E-Statement Analysis Monthly Tabulated Collection will be created.</li>
              <li class="mb-2">E-Statement Analysis Event will be added to Spin Mobile Category.</li>
            </ol>`;
const africasTalkingSmsMessage = `Installing the Africa's Talking SMS plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">Africa's Talking Option will be added to SMS Service in Send Dynamic SMS Event.</li>
              <li class="mb-2">A Africa's Talking SMS Activity Tracker Collection will be created.</li>
            </ol>`;
const hostPinnacleSmsMessage = `Installing the HostPinnacle plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">HostPinnacle Option will be added to SMS Service in Send Dynamic SMS Event.</li>
              <li class="mb-2">A HostPinnacle SMS Activity Tracker Collection will be created.</li>
            </ol>`;
const boldSignMessage = `Installing the BoldSign plugin will make the following changes to the project:<br/><br/>
            <ol class="px-3" style="text-align: left; font-size: 14px;">
              <li class="mb-2">BoldSign events will be added to the events categories.</li>
              <li class="mb-2">A BoldSign Signers Collection will be created.</li>
              <li class="mb-2">A BoldSign Contracts Collection will be created.</li>
            </ol>
            `;

export const checkToShowSaveBtn = (currentValues, oldValues) => {
  return _.isEqual(currentValues, oldValues);
};

export const checkToShowUpdateBtn = (code) => {
  let updateNotAllowedPlugins = [];
  return !updateNotAllowedPlugins.includes(code);
};

export const filterCollection = (collectionNames, finalSchema, apisSchema) => {
  const apis = [];
  collectionNames.forEach((collectionName) => {
    const selSchema = finalSchema[collectionName];
    let findAnyActive = false;
    if (selSchema) {
      findAnyActive = Object.values(selSchema.fields).find((field) => {
        return field.isEnabled;
      });
    }
    if (findAnyActive) {
      const selApi = apisSchema.find((api) => api.collectionName === collectionName);
      if (selApi) {
        apis.push({ collectionName, apis: selApi.apis });
      }
    }
  });
  return apis;
};

export const combineParametersAndRequestBody = (apisSchema, finalApisSchema) => {
  const prepareFinalApiSchema = [];
  Object.keys(finalApisSchema).forEach((collectionKey) => {
    const finalApiSchema = finalApisSchema[collectionKey];
    const apiSchema = apisSchema.find((api) => api.collectionName === collectionKey);
    const { apis } = apiSchema;
    const crudKeys = Object.keys(finalApiSchema);
    crudKeys.forEach((crudKey) => {
      const crudData = finalApiSchema[crudKey];
      if (crudData.uri) {
        const selApi = apis.find((apiKey) => {
          return apiKey.value === crudData.uri;
        });
        if (selApi) {
          crudData.parameters = selApi.parameters;
          crudData.bodyData = selApi.bodyData;
          crudData.host = selApi.host;
          crudData.customPagination = selApi.customPagination;
        }
      }
    });
  });
  return finalApisSchema;
};

export const createSchemaForPluginConfiguration = (fields, installedPluginId, pluginDetail) => {
  let schema = {};
  if (fields) {
    Object.entries(fields).forEach(([key, value]) => {
      schema[key] = value.value || value.value === false ? value.value : '';
    });
    if (installedPluginId && pluginDetail) {
      Object.keys(fields).forEach((field) => {
        schema[field] = pluginDetail.hasOwnProperty(field)
          ? pluginDetail[field]
          : schema.hasOwnProperty(field)
          ? schema[field]
          : '';
      });
    }
  }
  return schema;
};

export const prepareValidationForPluginConfiguration = (fields) => {
  let validationSchema = {};
  if (fields) {
    Object.keys(fields).forEach((field) => {
      const fieldDetail = fields[field];
      if (fieldDetail.required) {
        let yupDetail = '';
        if (fieldDetail.type === 'text' || fieldDetail.type === 'password') {
          yupDetail = Yup.string().required("Can't be blank");
        } else if (fieldDetail.type === 'number') {
          yupDetail = Yup.number().required("Can't be blank");
        } else if (fieldDetail.type === 'email') {
          yupDetail = Yup.string().email('Not a valid email').required("Can't be blank");
        }
        validationSchema[field] = yupDetail;
      }
    });
  }
  return Yup.object().shape(validationSchema);
};

export const checkPluginPermissions = (code) => {
  let newCode = '';
  switch (code) {
    case 'AMAZON_TEXTRACT':
      newCode = AWS_TEXTRACT;
      break;
    case 'ATOM_CHAT':
      newCode = ATOMCHAT;
      break;
    default:
      newCode = code;
      break;
  }
  let willAllow = restrictedPlugins.includes(newCode);
  if (!willAllow) {
    return true;
  }
  const permissions = loadOrganizationDetails('permissions');

  /**
   * When logged in from organization as a user, permissions is an array of string
   * When logged in from organization as an admin, permissions is a JSON object
   * So, we need to check if permissions is an array of string or JSON object
   */
  willAllow = permissions
    ? Array.isArray(permissions)
      ? permissions.includes(newCode)
      : true
    : false;
  return willAllow;
};

export const showInstallationAlert = (code, formData, resetForm, handler) => {
  const preConfirm = () => {
    resetForm();
    handler(formData);
  };
  switch (code) {
    case pluginCode.MULTI_TENANT_SAAS:
      showAlertHtml(multiTenantMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.DATA_FORM_SEARCH_HISTORY:
      showAlertHtml(dataFormMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.FILE_ACTIVITY_TRACKER:
      showAlertHtml(fileActivityMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.USER_ACTIVITY_TRACKER:
      showAlertHtml(userActivityMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.DATA_VIEW_ACTIVITY_TRACKER:
      showAlertHtml(dataActivityMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.TEXT_ANONYMIZATION_ACTIVITY_TRACKER:
      showAlertHtml(textAnonymizationMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.TYPESENSE_SEARCH:
      showAlertHtml(typesenseMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SOCKET_IO:
      showAlertHtml(socketMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SENDGRID:
      showAlertHtml(sendgridMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SIGNZY_ACCOUNT_AGGREGATOR:
      showAlertHtml(signzyAccountMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SIGNZY_DIGITAL_DOCUMENT_SIGNING:
      showAlertHtml(signzyDigitalMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.GOOGLE_CALENDAR:
      showAlertHtml(googleCalendarMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.PARKEN:
      showAlertHtml(parkenMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.RESEND:
      showAlertHtml(resendMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.GOOGLE_MEET:
      showAlertHtml(googleMeetMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.DOCUSIGN:
      showAlertHtml(docuSignMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.ZOOM:
      showAlertHtml(zoomMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.CIBIL:
      showAlertHtml(cibilMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.BOX:
      showAlertHtml(boxMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.QR_GENERATOR:
      showAlertHtml(qrMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.EMAIL_OTP_AUTHENTICATOR:
      showAlertHtml(emailOTPMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SMS_OTP_AUTHENTICATOR:
      showAlertHtml(smsOTPMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.EMAIL_OTP_CONSENT_VALIDATOR:
      showAlertHtml(emailConsentOTPMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SMS_OTP_CONSENT_VALIDATOR:
      showAlertHtml(smsConsentOTPMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.M_PESA:
      showAlertHtml(mPesaMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.SPIN_MOBILE:
      showAlertHtml(spinMobileMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.IPRS_KENYA:
      showAlertHtml(iprsKenyaMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.METROPOL_CREDIT_REPORTS_BUREAU_KENYA:
      showAlertHtml(metropolCreditReportsMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.KRA_PIN_CHECKER:
      showAlertHtml(kraPinCheckerMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.E_STATEMENT_ANALYSIS:
      showAlertHtml(eStatementAnalysisMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.AFRICAS_TALKING_SMS:
      showAlertHtml(africasTalkingSmsMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.HOSTPINNACLE:
      showAlertHtml(hostPinnacleSmsMessage, preConfirm, 'Proceed');
      break;
    case pluginCode.BOLDSIGN:
      showAlertHtml(boldSignMessage, preConfirm, 'Proceed');
      break;
    default:
      handler(formData);
      break;
  }
};

const prepMessage = (message) => {
  let alertMsg = "You won't be able to revert this.";
  return `${alertMsg}</br></br>
          <p style="text-align: left;">
          ${message}
          </p>
          `;
};

export const showDeleteAlert = (code) => {
  let alertMsg = "You won't be able to revert this.";
  let message = '';
  switch (code) {
    case pluginCode.MULTI_TENANT_SAAS:
      message = `
          1. Tenant Collection's reference field will be removed from all the existing collections.</br></br>
          2. A <em>All Items of Current LoggedIn User Tenant</em> filter will be removed from all the existing collections.</br></br>
          3. The selected Tenant collection will be reverted to default DrapCode collection.
          `;
      return prepMessage(message);
    case pluginCode.DATA_FORM_SEARCH_HISTORY:
      message = `
          1. Search History Collection will be removed.</br></br>
          2. Enable Search History trait option will be removed from the Data Search Form component.</br></br>
          `;
      return prepMessage(message);
    case pluginCode.FILE_ACTIVITY_TRACKER:
      message = `
       1. File Activity Tracker Collection will be removed.</br></br>
      `;
      return prepMessage(message);
    case pluginCode.USER_ACTIVITY_TRACKER:
      message = `
        1. User Login Activity Collection will be removed.</br></br>
      `;
      return prepMessage(message);
    case pluginCode.DATA_VIEW_ACTIVITY_TRACKER:
      message = `
      1. Data View Activity Tracker Collection will be removed.</br></br>
      `;
      return prepMessage(message);
    case pluginCode.TEXT_ANONYMIZATION_ACTIVITY_TRACKER:
      message = `
        1.Text Anonymization Activity Collection will be removed.</br></br>
       `;
      return prepMessage(message);
    case pluginCode.TYPESENSE_SEARCH:
      message = `
          1. Typesense Search capabilities will be removed.</br></br>
          2. Typesense Configuration will be permanently removed.</br></br>
          3. Typesense Events will no longer be visible.</br></br>
          4. Typesense Component will no longer be visible.</br></br> 
      `;
      return prepMessage(message);
    case pluginCode.SOCKET_IO:
      message = `
          1. Socket.IO capabilities will be removed.</br></br>
          2. Socket Actions will no longer be visible.</br></br>
          3. Socket.IO templates will no longer be visible.</br></br> 
          4. Socket.IO Activity Tracker Collection will be removed.</br></br>
      `;
      return prepMessage(message);
    case pluginCode.SENDGRID:
      message = `
        1. Email sending via SendGrid will be disabled.</br></br>
        2. The Send Dynamic Email action will no longer support the SendGrid service.</br></br>
        3. The SendGrid Activity Tracker collection will be deleted.</br></br>
      `;
      return prepMessage(message);
    case pluginCode.SIGNZY_ACCOUNT_AGGREGATOR:
      message = `
            1. The Account Aggregator FI Transactions collection will be deleted.</br></br>
            2. The Account Aggregator Account Holders collection will be deleted.</br></br>
            3. Signzy Account Aggregator Events will no longer be visible.</br></br>
            4. Request ID, Consent Handle and Internal ID fields will be removed from user collection.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.SIGNZY_DIGITAL_DOCUMENT_SIGNING:
      message = `
            1. The Digital Document Signing Signers collection will be deleted.</br></br>
            2. The Digital Document Signing Contracts collection will be deleted.</br></br>
            3. Signzy Digital Document Signing Events will no longer be visible.</br></br>
            4. Contract ID field will be removed from user collection.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.GOOGLE_CALENDAR:
      message = `
            1. The Google Calendar Events collection will be deleted.</br></br>
            2. The Google Calendar OAUTH Tokens collection will be deleted.</br></br>
            3. Google Calendar Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.PARKEN:
      message = `
            1. The Parken SMS Activity Tracker collection will be deleted.</br></br>
            2. Parken option will be removed from Send Dynamic SMS Action.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.RESEND:
      message = `
            1. Email sending via Resend will be disabled.</br></br>
            2. The Send Dynamic Email action will no longer support the Resend service.</br></br>
            3. The Resend Activity Tracker collection will be deleted.</br></br>
            `;
      return prepMessage(message);

    case pluginCode.GOOGLE_MEET:
      message = `
            1. The Google Meet OAUTH Tokens collection will be deleted.</br></br>
            2. Google Meet Events will no longer be visible.</br></br>
            3. Google Meet option will be removed from Conference Provider in the Schedule Google Calendar Event action.</br></br>
            `;
      return prepMessage(message);

    case pluginCode.DOCUSIGN:
      message = `
            1. The DocuSign Tokens collection will be deleted.</br></br>
            2. The DocuSign Contracts collection will be deleted.</br></br>
            3. The DocuSign Signers collection will be deleted.</br></br>
            4. The DocuSign Activity Tracker collection will be deleted.</br></br>
            5. DocuSign Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.ZOOM:
      message = `
            1. The Zoom OAUTH Tokens collection will be deleted.</br></br>
            2. Zoom Events will no longer be visible.</br></br>
            3. Zoom option will be removed from Conference Provider in the Schedule Google Calendar Event action.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.CIBIL:
      message = `
            1. CIBIL Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.BOX:
      message = `
            1. The Box OAUTH Tokens collection will be deleted.</br></br>
            2. Box Events will no longer be visible.</br></br>
            3. Box Folders List Component will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.QR_GENERATOR:
      message = `
            1. QR Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.EMAIL_OTP_AUTHENTICATOR:
      message = `
            1. The Email OTPs collection will be deleted.</br></br>
            2. Email OTP Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.SMS_OTP_AUTHENTICATOR:
      message = `
            1. The SMS OTPs collection will be deleted.</br></br>
            2. SMS OTP Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.EMAIL_OTP_CONSENT_VALIDATOR:
      message = `
            1. The Email Consent OTPs collection will be deleted.</br></br>
            2. Email Consent OTP Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.SMS_OTP_CONSENT_VALIDATOR:
      message = `
            1. The SMS Consent OTPs collection will be deleted.</br></br>
            2. SMS Consent OTP Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.M_PESA:
      message = `
            1. The MPesa OAUTH Tokens collection will be deleted.</br></br>
            2. The MPesa Callback Responses collection will be deleted.</br></br>
            3. M-Pesa Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.SPIN_MOBILE:
      message = `
            1. The Spin Mobile OAUTH Tokens collection will be deleted.</br></br>
            2. Spin Mobile Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.E_STATEMENT_ANALYSIS:
      message = `
            1. The E-Statement Analysis collection will be deleted.</br></br>
            2. The E-Statement Analysis Locations collection will be deleted.</br></br>
            3. The E-Statement Analysis Final Classifications collection will be deleted.</br></br>
            4. The E-Statement Analysis Monthly Tabulated collection will be deleted.</br></br>
            5. E-Statement Analysis Event will no longer be visible under Spin Mobile Category.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.AFRICAS_TALKING_SMS:
      message = `
            1. The Africa's Talking SMS Activity Tracker collection will be deleted.</br></br>
            2. Africa's Talking option will be removed from Send Dynamic SMS Action.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.HOSTPINNACLE:
      message = `
            1. The HostPinnacle SMS Activity Tracker collection will be deleted.</br></br>
            2. HostPinnacle option will be removed from Send Dynamic SMS Action.</br></br>
            `;
      return prepMessage(message);
    case pluginCode.BOLDSIGN:
      message = `
            1. The BoldSign Documents collection will be deleted.</br></br>
            2. The BoldSign Signers collection will be deleted.</br></br>
            3. BoldSign Events will no longer be visible.</br></br>
            `;
      return prepMessage(message);
    default:
      return alertMsg;
  }
};
